import { useSelector } from 'react-redux';
import { StoreState } from 'store';
import { ROUTES } from 'routes/constants';
import { PartnerNameEnum } from 'shared/enums/partner-name-enum';

export default function useRoot() {
  const authState = useSelector((state: StoreState) => state.auth);

  const defaultPage = determineDefaultHomePage(authState.partner);

  return {
    defaultPage,
  };
}

const determineDefaultHomePage = (
  partnerName: PartnerNameEnum | null
): string => {
  switch (partnerName) {
    default:
      return ROUTES.home;
  }
};
